export default __webpack_public_path__ + "static/media/border-join-bevel-17.71fc4bb8.svg";